"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorToHex = exports.hexToColor = void 0;
const colorMap = {
    "red": "#fe3018",
    "orange": "#fe8e23",
    "yellow": "#fed12f",
    "green": "#00d127",
    "blue": "#1ea4fc",
    "pink": "#fd8afc",
    "gray": "#bfbfbf",
    "grey": "#bfbfbf",
};
const hexToColor = (hex) => {
    const colorEntry = Object
        .entries(colorMap)
        .find(entry => {
        const [color, colorHex] = entry;
        return colorHex === hex;
    });
    return colorEntry && colorEntry[0];
};
exports.hexToColor = hexToColor;
const colorToHex = (color) => colorMap[color && color.toLowerCase()];
exports.colorToHex = colorToHex;
